function getOrderOnlineLink(title) {
  const linkMap = {
    "ring-a-wing-london-5234": "https://orders.iorders.online/ring-a-wing-london-5234/",
    "ring-a-wing-brantford-brantford-5308": "https://orders.iorders.online/ring-a-wing-brantford-brantford-5308/",
    "ring-a-wing-wonderland-london-5307": "https://orders.iorders.online/ring-a-wing-wonderland-london-5307/",
    "ring-a-wing-clarke-road-london-5306": "https://orders.iorders.online/ring-a-wing-clarke-road-london-5306/",
    "ring-a-wing-st-thomas-st-thomas-5310": "https://orders.iorders.online/ring-a-wing-st-thomas-st-thomas-5310/",
    "ring-a-wing-ernest-ave-london-5309": "https://orders.iorders.online/ring-a-wing-ernest-ave-london-5309/",
  };

  return linkMap[title] || "N/A";
}

// ... rest of the code remains unchanged
const storeDetails = {
  status: "success",
  data: {
    restaurants: [
      //1. Ring a Wing - Oxford St
      {
        profile: {
          id: 124,
          restaurant_name: "Ring a Wing - Oxford St",
          title: "ring-a-wing-london-5234",
          address: "941 Oxford St E, London, ON N5Y 3K1, Canada",
          phone: "+1 (519) 451-9464",
          available_days: [
            {
              id: 1746,
              day: "SUNDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 17461,
              day: "MONDAY",
              opening_time: "00:00:00",
              closing_time: "01:00:00",
              order_mode: 1,
            },
            {
              id: 1747,
              day: "MONDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 17471,
              day: "TUESDAY",
              opening_time: "00:00:00",
              closing_time: "01:00:00",
              order_mode: 1,
            },
            {
              id: 1748,
              day: "TUESDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 17481,
              day: "WEDNESDAY",
              opening_time: "00:00:00",
              closing_time: "01:00:00",
              order_mode: 1,
            },
            {
              id: 1749,
              day: "WEDNESDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 17491,
              day: "THURSDAY",
              opening_time: "00:00:00",
              closing_time: "01:00:00",
              order_mode: 1,
            },
            {
              id: 1750,
              day: "THURSDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 17501,
              day: "FRIDAY",
              opening_time: "00:00:00",
              closing_time: "02:00:00",
              order_mode: 1,
            },
            {
              id: 1751,
              day: "FRIDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 17511,
              day: "SATURDAY",
              opening_time: "00:00:00",
              closing_time: "03:00:00",
              order_mode: 1,
            },
            {
              id: 1752,
              day: "SATURDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 17521,
              day: "SUNDAY",
              opening_time: "00:00:00",
              closing_time: "01:00:00",
              order_mode: 1,
            },
          ],
          close_restaurent: false,
          lat: "43.00353635219002",
          lng: "-81.22437647031651",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },
      //2. Ring a Wing - Brantford
      {
        profile: {
          id: 125,
          restaurant_name: "Ring a Wing - Brantford",
          title: "ring-a-wing-brantford-brantford-5308",
          address: "395 St Paul Ave, Brantford, ON N3R 4N7, Canada",
          phone: "+1 (519) 304-8050",
          available_days: [
            {
              id: 2746,
              day: "SUNDAY",
              opening_time: "12:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 27461,
              day: "MONDAY",
              opening_time: "00:00:00",
              closing_time: "01:00:00",
              order_mode: 1,
            },
            {
              id: 2747,
              day: "MONDAY",
              opening_time: "12:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 27471,
              day: "TUESDAY",
              opening_time: "00:00:00",
              closing_time: "01:00:00",
              order_mode: 1,
            },
            {
              id: 2748,
              day: "TUESDAY",
              opening_time: "12:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 27481,
              day: "WEDNESDAY",
              opening_time: "00:00:00",
              closing_time: "01:00:00",
              order_mode: 1,
            },
            {
              id: 2749,
              day: "WEDNESDAY",
              opening_time: "12:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 27491,
              day: "THURSDAY",
              opening_time: "00:00:00",
              closing_time: "01:00:00",
              order_mode: 1,
            },
            {
              id: 2750,
              day: "THURSDAY",
              opening_time: "12:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 27501,
              day: "FRIDAY",
              opening_time: "00:00:00",
              closing_time: "01:00:00",
              order_mode: 1,
            },
            {
              id: 2751,
              day: "FRIDAY",
              opening_time: "12:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 27511,
              day: "SATURDAY",
              opening_time: "00:00:00",
              closing_time: "01:00:00",
              order_mode: 1,
            },
            {
              id: 2752,
              day: "SATURDAY",
              opening_time: "12:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 27521,
              day: "SUNDAY",
              opening_time: "00:00:00",
              closing_time: "01:00:00",
              order_mode: 1,
            },
          ],
          close_restaurent: false,
          lat: "43.15781465544621",
          lng: "-80.27250590152599",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },
      //3. Ring a Wing - Wonderland
      {
        profile: {
          id: 126,
          restaurant_name: "Ring a Wing - Wonderland",
          title: "ring-a-wing-wonderland-london-5307",
          address: "666 Wonderland Rd N, London, ON N6H 4K9, Canada",
          phone: "+1 (519) 474-9474",
          available_days: [
            {
              id: 3746,
              day: "SUNDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 37461,
              day: "MONDAY",
              opening_time: "00:00:00",
              closing_time: "03:00:00",
              order_mode: 1,
            },
            {
              id: 3747,
              day: "MONDAY",
              opening_time: "14:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 37471,
              day: "TUESDAY",
              opening_time: "00:00:00",
              closing_time: "03:00:00",
              order_mode: 1,
            },
            {
              id: 3748,
              day: "TUESDAY",
              opening_time: "14:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 37481,
              day: "WEDNESDAY",
              opening_time: "00:00:00",
              closing_time: "03:00:00",
              order_mode: 1,
            },
            {
              id: 3749,
              day: "WEDNESDAY",
              opening_time: "14:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 37491,
              day: "THURSDAY",
              opening_time: "00:00:00",
              closing_time: "05:00:00",
              order_mode: 1,
            },
            {
              id: 3750,
              day: "THURSDAY",
              opening_time: "14:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 37501,
              day: "FRIDAY",
              opening_time: "00:00:00",
              closing_time: "05:00:00",
              order_mode: 1,
            },
            {
              id: 3751,
              day: "FRIDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 37511,
              day: "SATURDAY",
              opening_time: "00:00:00",
              closing_time: "05:00:00",
              order_mode: 1,
            },
            {
              id: 3752,
              day: "SATURDAY",
              opening_time: "11:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 37521,
              day: "SUNDAY",
              opening_time: "00:00:00",
              closing_time: "03:00:00",
              order_mode: 1,
            },
          ],
          close_restaurent: false,
          lat: "42.98479848913665",
          lng: "-81.29333217716045",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },
      //4. Ring a Wing - Clarke Road
      {
        profile: {
          id: 127,
          restaurant_name: "Ring a Wing - Clarke Road",
          title: "ring-a-wing-clarke-road-london-5306",
          address: "161 Clarke Rd, London, ON N5W 5Y7, Canada",
          phone: "+1 (519) 204-9464",
          available_days: [
            {
              id: 4746,
              day: "SUNDAY",
              opening_time: "12:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 4747,
              day: "MONDAY",
              opening_time: "12:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 4748,
              day: "TUESDAY",
              opening_time: "12:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 4749,
              day: "WEDNESDAY",
              opening_time: "12:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 4750,
              day: "THURSDAY",
              opening_time: "12:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 4751,
              day: "FRIDAY",
              opening_time: "12:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 47511,
              day: "SATURDAY",
              opening_time: "00:00:00",
              closing_time: "01:00:00",
              order_mode: 1,
            },
            {
              id: 4752,
              day: "SATURDAY",
              opening_time: "12:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 47521,
              day: "SUNDAY",
              opening_time: "00:00:00",
              closing_time: "01:00:00",
              order_mode: 1,
            },
          ],
          close_restaurent: false,
          lat: "42.9928836887184",
          lng: "-81.17063902885647",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },
      //5. Ring A Wing - St.Thomas
      {
        profile: {
          id: 128,
          restaurant_name: "Ring A Wing - St.Thomas",
          title: "ring-a-wing-st-thomas-st-thomas-5310",
          address: "184 Sunset Dr, St. Thomas, ON N5R 3B9, Canada",
          phone: "+1 (519) 207-3001",
          available_days: [
            {
              id: 5746,
              day: "SUNDAY",
              opening_time: "15:00:00",
              closing_time: "22:00:00",
              order_mode: 1,
            },
            {
              id: 5747,
              day: "MONDAY",
              opening_time: "15:00:00",
              closing_time: "21:00:00",
              order_mode: 1,
            },
            {
              id: 5748,
              day: "TUESDAY",
              opening_time: "15:00:00",
              closing_time: "21:00:00",
              order_mode: 1,
            },
            {
              id: 5749,
              day: "WEDNESDAY",
              opening_time: "15:00:00",
              closing_time: "21:00:00",
              order_mode: 1,
            },
            {
              id: 5750,
              day: "THURSDAY",
              opening_time: "15:00:00",
              closing_time: "22:00:00",
              order_mode: 1,
            },
            {
              id: 5751,
              day: "FRIDAY",
              opening_time: "15:00:00",
              closing_time: "23:00:00",
              order_mode: 1,
            },
            {
              id: 5752,
              day: "SATURDAY",
              opening_time: "15:00:00",
              closing_time: "23:00:00",
              order_mode: 1,
            },
          ],
          close_restaurent: false,
          lat: "42.76317390291278",
          lng: "-81.19706662769859",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },
      //6. Ring a Wing - Ernest Ave
      {
        profile: {
          id: 129,
          restaurant_name: "Ring a Wing - Ernest Ave",
          title: "ring-a-wing-ernest-ave-london-5309",
          address: "1775 Ernest Ave, London, ON N6E 2V5, Canada",
          phone: "+1 (519) 681-9474",
          available_days: [
            {
              id: 6746,
              day: "SUNDAY",
              opening_time: "12:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 67461,
              day: "MONDAY",
              opening_time: "00:00:00",
              closing_time: "02:00:00",
              order_mode: 1,
            },
            {
              id: 6747,
              day: "MONDAY",
              opening_time: "15:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 67471,
              day: "TUESDAY",
              opening_time: "00:00:00",
              closing_time: "01:00:00",
              order_mode: 1,
            },
            {
              id: 6748,
              day: "TUESDAY",
              opening_time: "15:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 67481,
              day: "WEDNESDAY",
              opening_time: "00:00:00",
              closing_time: "01:00:00",
              order_mode: 1,
            },
            {
              id: 6749,
              day: "WEDNESDAY",
              opening_time: "15:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 67491,
              day: "THURSDAY",
              opening_time: "00:00:00",
              closing_time: "01:00:00",
              order_mode: 1,
            },
            {
              id: 6750,
              day: "THURSDAY",
              opening_time: "15:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 67501,
              day: "FRIDAY",
              opening_time: "00:00:00",
              closing_time: "01:00:00",
              order_mode: 1,
            },
            {
              id: 6751,
              day: "FRIDAY",
              opening_time: "12:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 67511,
              day: "SATURDAY",
              opening_time: "00:00:00",
              closing_time: "02:00:00",
              order_mode: 1,
            },
            {
              id: 6752,
              day: "SATURDAY",
              opening_time: "12:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 67521,
              day: "SUNDAY",
              opening_time: "00:00:00",
              closing_time: "02:00:00",
              order_mode: 1,
            },
          ],
          close_restaurent: false,
          lat: "42.94169529997022",
          lng: "-81.23717787331546",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },
    ],
  },
  message: "successful response",
};

export default storeDetails;
